import MasqueradeBar from './MasqueradeBar'

export default MasqueradeBar
